(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrito-new-lateral"] && !Shopify.designMode) return;
  try {
    
  class CarritoNewLateral extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.isOpen = false;
      this.drawer = this.querySelector('.cnl__drawer');
      this.body = this.querySelector('#cnl-body');
      this.footer = this.querySelector('#cnl-footer');
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onAutoGiftChanged = this.onAutoGiftChanged.bind(this);
      this.nativeFetch = window.fetch.bind(window);
      // Keep a pristine fetch for gift picker / other tools.
      if (!window.__nativeFetch) window.__nativeFetch = this.nativeFetch;
    }

    connectedCallback() {
      if (!this.sectionId) return;

      this.querySelectorAll('[data-cnl-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      this.addEventListener('click', (event) => {
        const checkoutBtn = event.target.closest('[data-cnl-checkout]');
        if (checkoutBtn) {
          event.preventDefault();
          this.onCheckout(checkoutBtn);
          return;
        }

        const qtyBtn = event.target.closest('[data-cnl-qty]');
        if (qtyBtn) {
          event.preventDefault();
          this.changeQuantity(qtyBtn);
          return;
        }

        const removeBtn = event.target.closest('[data-cnl-remove]');
        if (removeBtn) {
          event.preventDefault();
          this.removeItem(removeBtn.dataset.line);
          return;
        }

        const recAddBtn = event.target.closest('[data-cnl-rec-add]');
        if (recAddBtn) {
          event.preventDefault();
          this.addRecommendation(recAddBtn);
        }
      });

      document.addEventListener('submit', this.onSubmit, true);
      document.addEventListener('click', this.onDocumentClick, true);
      document.addEventListener('auto-gift:changed', this.onAutoGiftChanged);
      this.syncQuantityLocks();
      this.patchFetch();
    }

    patchFetch() {
      if (window.__cnlFetchPatched) return;
      window.__cnlFetchPatched = true;
      const nativeFetch = this.nativeFetch;

      window.fetch = async (...args) => {
        const response = await nativeFetch(...args);
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
        const instance = document.querySelector('carrito-new-lateral');

        // Gift picker uses its own cart sync + refresh. Don't interrupt it.
        if (window.__autoGiftBusy || window.AutoGift?.isBusy?.()) {
          return response;
        }

        if (response.ok && instance && !instance._skipFetchOpen && /\/cart\/(add|change|update)(\.js)?/i.test(url)) {
          const shouldOpen = url.includes('/cart/add');
          await instance.afterCartUpdate({ open: shouldOpen });
        }

        return response;
      };
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
      document.removeEventListener('click', this.onDocumentClick, true);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('auto-gift:changed', this.onAutoGiftChanged);
    }

    async onAutoGiftChanged() {
      if (!this.isOpen) return;
      try {
        await this.refresh();
      } catch (error) {
        console.error('[carrito-new-lateral]', error);
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) this.close();
    }

    onDocumentClick(event) {
      const trigger = event.target.closest('[data-cnl-open]');
      if (!trigger) return;
      event.preventDefault();
      this.afterCartUpdate({ open: true });
    }

    async onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes('/cart/add')) return;

      event.preventDefault();
      event.stopPropagation();

      const formData = new FormData(form);
      this._skipFetchOpen = true;
      const response = await this.nativeFetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      this._skipFetchOpen = false;

      if (!response.ok) {
        const error = await response.json();
        alert(error.description || error.message || 'Error adding to cart');
        return;
      }

      await this.afterCartUpdate({ open: true });
    }

    async waitForAutoGift(maxMs = 3000) {
      const start = Date.now();
      while (!window.AutoGift?.runSync && Date.now() - start < maxMs) {
        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }
    }

    async syncGifts() {
      await this.waitForAutoGift();
      if (window.AutoGift?.afterCartChange) return window.AutoGift.afterCartChange();
      if (window.AutoGift?.runSync) return window.AutoGift.runSync();
      return { changed: false };
    }

    async afterCartUpdate({ open = false } = {}) {
      try {
        await this.syncGifts();
      } catch (error) {
        console.error('[carrito-new-lateral]', error);
      }
      await this.refresh();
      if (open) this.open();
    }

    async onCheckout(button) {
      if (button.disabled) return;
      button.disabled = true;
      try {
        await this.afterCartUpdate();
        this.submitCheckout();
      } catch (error) {
        console.error('[carrito-new-lateral]', error);
        button.disabled = false;
      }
    }

    submitCheckout() {
      const routesEl = document.querySelector('[data-cart-routes]');
      let cartUrl = '/cart';
      if (routesEl) {
        try {
          cartUrl = JSON.parse(routesEl.textContent).cartUrl || cartUrl;
        } catch (error) {
          console.error('[carrito-new-lateral]', error);
        }
      }
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = cartUrl;
      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      form.appendChild(checkoutInput);
      document.body.appendChild(form);
      form.submit();
    }

    open() {
      if (this.isOpen) return;
      this.syncQuantityLocks();
      this.wireGiftButtons();
      this.isOpen = true;
      this.hidden = false;
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        document.body.classList.add('cnl-open');
        this.drawer.focus();
      });
      document.addEventListener('keydown', this.onKeydown);
      this.loadRecommendations();
    }

    wireGiftButtons() {
      if (window.AutoGift?.wireButtons) {
        window.AutoGift.wireButtons(this);
        return;
      }
      this.querySelectorAll('[data-auto-gift-option]').forEach((btn) => {
        btn.onclick = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (window.__pickGift) window.__pickGift(btn);
        };
      });
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      document.body.classList.remove('cnl-open');
      document.removeEventListener('keydown', this.onKeydown);
      window.setTimeout(() => {
        if (!this.isOpen) this.hidden = true;
      }, 350);
    }

    async refresh() {
      const response = await this.nativeFetch(
        `${window.Shopify.routes.root}?sections=${this.sectionId}`
      );
      const data = await response.json();
      const html = data[this.sectionId];
      if (!html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newBody = doc.querySelector('#cnl-body');
      const newFooter = doc.querySelector('#cnl-footer');

      if (newBody) {
        this.body.innerHTML = newBody.innerHTML;
      }
      if (newFooter) {
        this.footer.innerHTML = newFooter.innerHTML;
        this.footer.hidden = newFooter.hasAttribute('hidden');
      }

      this.wireGiftButtons();
      if (window.AutoGift?.updatePickerUI) {
        try {
          await window.AutoGift.updatePickerUI();
        } catch (e) {}
      }

      await this.syncQuantityLocks();
      await this.loadRecommendations();
    }

    formatRecMoney(cents) {
      const amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
        }).format(amount);
      } catch (e) {
        return '€' + amount.toFixed(2).replace('.', ',');
      }
    }

    async loadRecommendations() {
      const root = this.querySelector('[data-cnl-recs]');
      if (!root) return;

      const list = root.querySelector('[data-cnl-recs-list]');
      const emptyMsg = root.querySelector('[data-cnl-recs-empty]');
      const productId = root.dataset.productId;
      if (!list || !productId) return;

      // Si Liquid ya pintó sugeridos de colección, no los pises salvo que la API traiga algo.
      const hasLiquidItems = list.querySelector('.cnl-recs__item');

      const exclude = new Set(
        String(root.dataset.excludeIds || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean)
      );

      try {
        const url =
          window.Shopify.routes.root +
          'recommendations/products.json?product_id=' +
          encodeURIComponent(productId) +
          '&limit=8&intent=related';
        const response = await this.nativeFetch(url, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;

        const data = await response.json();
        const products = (data.products || [])
          .filter((product) => product.available !== false && !exclude.has(String(product.id)))
          .slice(0, 4);

        if (!products.length) return;

        const html = products
          .map((product) => {
            const variant =
              (product.variants || []).find((item) => item.available) || product.variants?.[0];
            if (!variant) return '';

            let image =
              typeof product.featured_image === 'string'
                ? product.featured_image
                : product.featured_image?.url || product.featured_image?.src || '';
            if (!image && product.images?.length) {
              image =
                typeof product.images[0] === 'string'
                  ? product.images[0]
                  : product.images[0]?.src || '';
            }

            const title = String(product.title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            const href = product.url || '#';
            const price = this.formatRecMoney(variant.price);

            return (
              '<article class="cnl-recs__item">' +
              '<a class="cnl-recs__media" href="' +
              href +
              '">' +
              (image
                ? '<img src="' +
                  image +
                  '" alt="' +
                  title +
                  '" width="64" height="64" loading="lazy">'
                : '') +
              '</a>' +
              '<div class="cnl-recs__info">' +
              '<a class="cnl-recs__name" href="' +
              href +
              '">' +
              title +
              '</a>' +
              '<p class="cnl-recs__price">' +
              price +
              '</p>' +
              '</div>' +
              '<button type="button" class="cnl-recs__add" data-cnl-rec-add data-variant-id="' +
              variant.id +
              '">Add</button>' +
              '</article>'
            );
          })
          .join('');

        if (!html.trim()) return;

        list.innerHTML = html;
        if (emptyMsg) emptyMsg.remove();
        root.hidden = false;
      } catch (error) {
        console.error('[carrito-new-lateral] recommendations', error);
        if (!hasLiquidItems) {
          // deja el mensaje vacío de Liquid si existe
        }
      }
    }

    async addRecommendation(button) {
      const variantId = Number(button.dataset.variantId);
      if (!variantId || button.disabled) return;

      button.disabled = true;
      try {
        const response = await this.nativeFetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          alert(error.description || error.message || 'Could not add product');
          return;
        }
        await this.afterCartUpdate({ open: true });
      } catch (error) {
        console.error('[carrito-new-lateral]', error);
      } finally {
        button.disabled = false;
      }
    }

    isStlCartItem(item) {
      const properties = item?.properties || {};

      return Object.entries(properties).some(([rawKey, rawValue]) => {
        const key = String(rawKey || '').trim().toLowerCase();
        const value = String(rawValue ?? '').trim().toLowerCase();

        if (key === '_stl_item' && value === 'true') return true;

        return (
          ['shop the look', 'ushop the look', '_stl_bundle'].includes(key) &&
          value.startsWith('stl-')
        );
      });
    }

    async syncQuantityLocks(scope = this.body) {
      if (!scope) return;

      try {
        const response = await this.nativeFetch(window.Shopify.routes.root + 'cart.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });

        if (response.ok) {
          const cart = await response.json();
          const rows = Array.from(scope.querySelectorAll('.cnl__items-row'));

          rows.forEach((row, index) => {
            const item = cart.items?.[index];
            const locked = this.isStlCartItem(item);
            row.dataset.cnlQuantityLocked = locked ? 'true' : 'false';
            row.classList.toggle('is-quantity-locked', locked);
          });
        }
      } catch (error) {
        console.error('[carrito-new-lateral] Could not verify STL quantities', error);
      }

      this.lockQuantitySelectors(scope);
    }

    isQuantityLocked(element) {
      return Boolean(element?.closest('[data-cnl-quantity-locked="true"]'));
    }

    lockQuantitySelectors(scope = this.body) {
      if (!scope) return;

      const rows = scope.querySelectorAll('[data-cnl-quantity-locked="true"]');

      rows.forEach((row) => {
        row.classList.add('is-quantity-locked');

        const existingHiddenGroup = row.querySelector('[data-cnl-quantity-hidden="true"]');
        if (existingHiddenGroup) {
          existingHiddenGroup.hidden = true;
          existingHiddenGroup.setAttribute('aria-hidden', 'true');
          return;
        }

        const quantityButtons = Array.from(row.querySelectorAll('[data-cnl-qty]'));
        const allControls = Array.from(
          row.querySelectorAll(
            [
              '[data-cnl-qty]',
              '[data-quantity-input]',
              'input[name="updates[]"]',
              'input[name^="updates["]',
              'input[type="number"]',
              'select[name="updates[]"]',
            ].join(',')
          )
        );

        allControls.forEach((control) => {
          control.setAttribute('aria-disabled', 'true');
          control.setAttribute('tabindex', '-1');
          if ('disabled' in control) control.disabled = true;
          if ('readOnly' in control) control.readOnly = true;
        });

        /*
         * El snippet no tiene un contenedor de cantidad identificable.
         * Por eso agrupamos exactamente desde el botón menos hasta el botón más,
         * incluyendo el número que queda entre ambos, y ocultamos ese grupo.
         */
        if (quantityButtons.length >= 2) {
          const firstButton = quantityButtons[0];
          const lastButton = quantityButtons[quantityButtons.length - 1];

          if (firstButton.parentElement === lastButton.parentElement) {
            const parent = firstButton.parentElement;
            const hiddenGroup = document.createElement('span');
            hiddenGroup.className = 'cnl-quantity-hidden';
            hiddenGroup.dataset.cnlQuantityHidden = 'true';
            hiddenGroup.hidden = true;
            hiddenGroup.setAttribute('aria-hidden', 'true');

            parent.insertBefore(hiddenGroup, firstButton);

            let currentNode = firstButton;
            while (currentNode) {
              const nextNode = currentNode.nextSibling;
              hiddenGroup.appendChild(currentNode);
              if (currentNode === lastButton) break;
              currentNode = nextNode;
            }

            return;
          }
        }

        const knownWrapper = row.querySelector(
          [
            '[data-cnl-quantity-selector]',
            '[data-quantity-selector]',
            '.quantity',
            '.quantity-selector',
            '.cnl__quantity',
            '.cnl-item__quantity',
          ].join(',')
        );

        if (knownWrapper && !knownWrapper.querySelector('[data-cnl-remove]')) {
          knownWrapper.classList.add('cnl-quantity-hidden');
          knownWrapper.dataset.cnlQuantityHidden = 'true';
          knownWrapper.hidden = true;
          knownWrapper.setAttribute('aria-hidden', 'true');
          return;
        }

        /* Último fallback: al menos nunca dejamos botones de cantidad activos. */
        allControls.forEach((control) => {
          control.classList.add('cnl-quantity-hidden');
          control.dataset.cnlQuantityHidden = 'true';
          control.hidden = true;
          control.setAttribute('aria-hidden', 'true');
        });
      });
    }

    async changeQuantity(button) {
      if (this.isQuantityLocked(button)) return;

      const line = button.dataset.line;
      const current = parseInt(button.dataset.quantity, 10);
      const delta = button.dataset.cnlQty === 'plus' ? 1 : -1;
      await this.updateCart(line, Math.max(0, current + delta));
    }

    async removeItem(line) {
      await this.updateCart(line, 0);
    }

    async updateCart(line, quantity) {
      const row = this.body?.querySelector(`[data-cnl-line="${line}"]`);
      if (quantity > 0 && this.isQuantityLocked(row)) return;

      const response = await this.nativeFetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity }),
      });
      if (!response.ok) return;
      const cart = await response.json();
      await this.afterCartUpdate();
      if (cart.item_count === 0) this.close();
    }
  }

  if (!customElements.get('carrito-new-lateral')) {
    customElements.define('carrito-new-lateral', CarritoNewLateral);
  }

  } catch(e) { console.error(e); }
})();
})();
